import React, { lazy } from 'react';
import { PriceDisplay } from './PriceDisplay';
import { Check, Lock } from 'lucide-react';
export function OrderSummary() {
  const cartLink = 'https://superlibrodigital.com/cart/clear?return_to=/cart/add?id=56060036874566&quantity=1';
  const items = [{
    name: 'Biblia Visual — Guía Completa (500+ págs, 280+ imgs)',
    price: 49.99
  }, {
    name: 'Bono #1 — Guía de Pueblos Antiguos',
    price: 19
  }, {
    name: 'Bono #2 — Cronología Bíblica Ilustrada',
    price: 29
  }, {
    name: 'Bono #3 — Atlas de Mapas Bíblicos',
    price: 15
  }, {
    name: 'Bono #4 — Diccionario de Lugares Sagrados',
    price: 25
  }, {
    name: 'Bono #5 — Guía del Templo de Salomón',
    price: 19
  }, {
    name: 'Bono #6 — Guía de Estudio Interactiva',
    price: 15
  }, {
    name: 'Bono #7 — Actualizaciones de Por Vida',
    price: 'Infinito'
  }];
  return <section className="py-8 md:py-16 bg-white content-section" data-id="element-249">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-250">
        <div className="bg-white rounded-2xl shadow-2xl border-2 border-gold-200 overflow-hidden" data-id="element-251">
          <div className="bg-navy-900 p-4 md:p-6 text-center" data-id="element-252">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-white" data-id="element-253">
              Resumen de Todo Lo Que Recibes Hoy
            </h2>
          </div>

          <div className="p-4 md:p-8 bg-parchment-50" data-id="element-254">
            {/* Image Placeholder */}
            <div className="mb-4 md:mb-8 flex justify-center" data-id="element-255">
              <img src="https://cdn.magicpatterns.com/uploads/kXi2Fqs5D11ubtLiC4Gjuf/20260225_1349_Image_Generation_simple_compose_01kjav77w8f2wrzq7hhc4dkpn4.png" alt="Biblia Visual — Paquete Completo" loading="lazy" width="400" height="300" className="w-full max-w-xs md:max-w-md rounded-xl shadow-lg" data-id="element-256" />
            </div>

            {/* Line Items */}
            <div className="space-y-2 mb-4 md:space-y-3 md:mb-8" data-id="element-257">
              {items.map((item, index) => <div key={index} className="flex justify-between items-center text-sm md:text-base border-b border-gray-200 pb-2 last:border-0" data-id="element-258">
                  <div className="flex items-start" data-id="element-259">
                    <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-260" />
                    <span className={`text-gray-700 ${index === 0 ? 'font-bold text-navy-900' : ''}`} data-id="element-261">
                      {item.name}
                    </span>
                  </div>
                  <span className={`ml-2 whitespace-nowrap ${item.price === 0 || item.price === 'Infinito' ? 'font-bold text-gold-600' : 'text-gray-400 line-through'}`} data-id="element-262">
                    {typeof item.price === 'number' ? `$${item.price}` : item.price}
                  </span>
                </div>)}
            </div>

            {/* Total Value */}
            <div className="flex justify-between items-center py-3 md:py-4 border-t-2 border-dashed border-gray-300 mb-4 md:mb-6" data-id="element-263">
              <span className="font-bold text-gray-600 text-lg uppercase tracking-wide" data-id="element-264">
                VALOR TOTAL:
              </span>
              <span className="font-bold text-gray-400 line-through text-xl decoration-red-500 decoration-2" data-id="element-265">
                $171.99+
              </span>
            </div>

            {/* Final Price */}
            <div className="text-center bg-gold-50 rounded-xl p-4 md:p-6 border border-gold-200 mb-4 md:mb-8 shadow-inner" data-id="element-266">
              <p className="text-gray-600 mb-2 font-medium" data-id="element-267">
                Hoy lo obtienes{' '}
                <span className="font-bold text-navy-900" data-id="element-268">TODO</span> por solo:
              </p>
              <PriceDisplay amount={9.99} className="text-4xl md:text-5xl font-bold text-burgundy-600 highlight-gold inline-block px-4" showCurrencyCode={true} data-id="element-269" />
            </div>

            {/* CTA */}
            <a href={cartLink} className="block w-full text-center bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-xl uppercase tracking-wide will-change-transform" data-id="element-270">
              AGREGAR AL CARRITO »
            </a>

            <div className="mt-4 flex flex-col md:flex-row items-center justify-center gap-4 text-xs text-gray-500 font-medium" data-id="element-271">
              <span className="flex items-center" data-id="element-272">
                <Lock className="w-3 h-3 mr-1 text-gray-400" data-id="element-273" /> Pago único
                seguro
              </span>
              <span className="hidden md:inline" data-id="element-274">·</span>
              <span data-id="element-275">Acceso inmediato</span>
              <span className="hidden md:inline" data-id="element-276">·</span>
              <span data-id="element-277">120 días de garantía</span>
            </div>

            <p className="text-center text-xs text-red-500 mt-4 italic font-medium" data-id="element-278">
              Me reservo el derecho de cerrar esta oferta sin aviso previo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}